import {ImageListItem, Grid} from '../../../ui-library';
import {ImageUrl} from '../../ImageUrl';
import React, {useState} from 'react';
import {IMAGE_ITEMS_MOCK, square_box_sizes} from '../Config/ManualRefinementImageList.constants';
import useManualRefinementImageList from '../Controller/useManualRefinementImageList.controller';
import useImageModalView from '../../ImageModalView/Controller/useImageModalView.controller';
import {IProps} from '../Config/ManualRefinementImageList.types';
import {FLOW} from '../../../pages/RandomSampler/Config/RandomSampler.constants';
import AutoClassGalleryView from '../../AutoClassGallery/View/AutoClassGallery.view';

const ManualRefinementImageList = ({manualRefinementState, setState, isChoseAnotherClass = false, disableDelete = null, isGlobalLoading = false, flow = '', onDeleteFunc = () => {}}:IProps) => {
    const imageList = manualRefinementState.manualImages.length > 0 ? manualRefinementState.manualImages : IMAGE_ITEMS_MOCK;
    const {
        setApproved,
        removeChosenClass} = useManualRefinementImageList(manualRefinementState, setState);
    const {
        open,
        setOpen,
        activeHover,
        setActiveHover,
        setCurrentImageIndex,
        currentImageIndex} = useImageModalView();
    const imageGrid = flow === FLOW.autoClasses ? 2.4 : 3;
    const [currentImage, setCurrentImage] = useState({});


    return (
        <>
            <AutoClassGalleryView
                itemData={imageList}
                onDeleteFile={onDeleteFunc}
                chosenImage={currentImage}
                open={open}
                setOpen={setOpen}
                currentImageIndex={currentImageIndex}
                setCurrentImageIndex={setCurrentImageIndex}
                setCurrentImage={setCurrentImage}
                flow={flow}
            />
            <Grid container spacing={3} style={{ overflow: 'auto', padding: 5}}>
                {imageList.map((img, i) => (
                    <Grid item xs={imageGrid} sm={imageGrid} md={imageGrid} lg={2.4} key={i}>
                        <ImageListItem cols={1}>
                            <ImageUrl
                                disableDelete={disableDelete}
                                isChoseAnotherClass={isChoseAnotherClass}
                                onMouseOver={() => setActiveHover(i)}
                                onMouseLeave={() => setActiveHover(-1)}
                                isHover={activeHover === i}
                                isGlobalLoading={isGlobalLoading}
                                isCleanClick={manualRefinementState.isCleanClick}
                                isAspectRatio={true}
                                bgcolor='#FFFFFF'
                                getIsClicked={() => manualRefinementState.manualImages.length > 0 && setApproved(i, null)}
                                img={img}
                                width={square_box_sizes}
                                height={square_box_sizes}
                                imageIndex={i}
                                manualRefinementState={manualRefinementState}
                                setApproved={setApproved}
                                fromManual={true}
                                removeChosenClass={removeChosenClass}
                                setOpen={setOpen}
                                setCurrentImageIndex={setCurrentImageIndex}
                                isMoveMode={manualRefinementState.isMoveToAnotherClass}
                                flow={flow}
                                onDeleteFile={onDeleteFunc}
                            />

                        </ImageListItem>
                    </Grid>
                ))}
            </Grid>
        </>
    );

};

export default ManualRefinementImageList;
